import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { mapToDraughtRequirements } from "./mapToDraughtRequirements";
import { useState } from "react";
import { CheckoutDraughtDutyOption } from "./types";

type CheckoutEditDraughtDutyFormProps = {
  initialData: CheckoutDraughtDutyOption;
  onConfirm: (data: CheckoutDraughtDutyOption) => void;
};

type DraughtDuty = { draughtDuty: CheckoutDraughtDutyOption };

export const CheckoutEditDraughtDutyForm = ({
  initialData,
  onConfirm,
}: CheckoutEditDraughtDutyFormProps) => {
  const { register, handleSubmit } = useForm<DraughtDuty>({
    defaultValues: { draughtDuty: initialData },
    shouldUseNativeValidation: true,
  });
  const [currentDraughtDuty, setCurrentDraughtDuty] =
    useState<CheckoutDraughtDutyOption>(initialData);

  const handleUserSubmit = (data: DraughtDuty) => {
    onConfirm(data.draughtDuty);
  };

  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={handleSubmit(handleUserSubmit)}
    >
      <div className="text-center text-gray-500">
        Do you intend to sell any of the keg and/or cask products in your order
        in growlers or as take-away pints? Please see{" "}
        <a
          href="https://www.gov.uk/guidance/check-if-you-can-pay-less-alcohol-duty-on-draught-products"
          target="_blank"
          rel="noopener noreferrer"
        >
          gov.uk
        </a>{" "}
        for further guidance
      </div>
      <div className="flex flex-col divide-y-2 divide-zinc-200 rounded-lg border border-zinc-300">
        {draughtOptions.map((draughtOption) => (
          <label
            htmlFor={draughtOption.label}
            key={draughtOption.label}
            className="flex items-center gap-2 p-6 hover:cursor-pointer has-checked:bg-gray-200"
          >
            <input
              {...register("draughtDuty", { required: true })}
              className="h-5 w-5 appearance-none rounded-full border-2 border-gray-800 text-black checked:border-[6px] checked:bg-white"
              id={draughtOption.label}
              type="radio"
              checked={draughtOption.value === currentDraughtDuty}
              value={draughtOption.value}
              onChange={(event) =>
                setCurrentDraughtDuty(
                  event.target.value as CheckoutDraughtDutyOption,
                )
              }
            />
            <span className="font-semibold text-zinc-800">
              {draughtOption.label}
            </span>
          </label>
        ))}
      </div>

      <Button type="submit" className="w-full">
        Update
      </Button>
    </form>
  );
};

const draughtOptions = [
  {
    label: mapToDraughtRequirements("yes"),
    value: "yes",
  },
  {
    label: mapToDraughtRequirements("no"),
    value: "no",
  },
];
